<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item" style="min-width: 350px">
        <span class="label">当期保费到期日</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          :editable="false"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.expireDate"
          @on-change="searchParams.expireDate = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyId" clearable filterable @on-change="companyChange()">
          <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">保单编号</span>
        <Input type="text" v-model="searchParams.policyNo" placeholder="请输入" />
      </div>
      <div class="input-item" style="min-width: 350px">
        <span class="label">保单生效日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          :editable="false"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.effectDate"
          @on-change="searchParams.effectDate = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">投保人姓名</span>
        <Input type="text" v-model="searchParams.name" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">归属员工</span>
        <Select v-model="searchParams.agentId" clearable filterable>
          <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">{{ isIFA ? '归属团队' : '归属转介人' }}</span>
        <select-tree
          v-model="searchParams.id"
          type="5"
          url="/buz/merchant/read/tree"
          :params="{ nodeType: 0 }"
          :isAll="true"
          ref="selectTree"
          @change="changeTenant"
        />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <!-- <Button type="warning" ghost @click="handleExport">导出</Button> -->
      </div>
    </div>
    <Tabs v-model="searchParams.renewalState" :animated="false" @on-click="searchAjax()">
      <TabPane :label="() => getNumText('全部', 'null')" name="-1"></TabPane>
      <TabPane :label="() => getNumText('未缴费', '0-1')" name="0"></TabPane>
      <TabPane :label="() => getNumText('已添加对账申请', '2')" name="2"></TabPane>
      <TabPane :label="() => getNumText('已提交保司对账', '3')" name="3"></TabPane>
      <TabPane :label="() => getNumText('保司已入账', '4')" name="4"></TabPane>
      <TabPane :label="() => getNumText('续期成功', '5')" name="5"></TabPane>
      <TabPane :label="() => getNumText('保费逾期', '6')" name="6"></TabPane>
      <TabPane :label="() => getNumText('已失效', '7')" name="7"></TabPane>
    </Tabs>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="policyNo">
          <span class="table-btn" @click="goPolicy(row)" v-if="row.policyNo">{{ row.policyNo }}</span>
          <span class="table-btn disabled" v-else>暂未生成</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span @click="goDetail(row)" class="table-btn">详情</span>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        show-sizer
        :page-size-opts="[10, 20, 30, 50, 100]"
        style="text-align: center"
      />
    </div>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzSelect from '@/components/commons/lzSelect';
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';
const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};
export default {
  mixins: [pageTool, common, config],
  components: {
    selectTree,
    lzSelect,
    lzDicTxt
  },
  data() {
    return {
      userInfo,
      companyList: [],
      searchProductList: [],
      statistics: {},
      searchParams: {},
      userList: []
    };
  },
  watch: {},
  mounted() {
    this.initListParams('/buz/policy/renewal/page');
  },
  computed: {
    isIFA() {
      return this.userInfo.isIFA;
    }
  },
  activated() {
    this.getList();
    this.queryCompanyList();
    this.companyChange();
    this.getUserList();
  },
  methods: {
    changeTenant(data) {
      console.log(data);
      if (data.nodeType == 1) {
        this.searchParams.groupId = '';
        this.searchParams.tenantId = data.id;
      } else if (data.nodeType == 2) {
        this.searchParams.groupId = data.id;
        this.searchParams.tenantId = data.parentId;
      } else {
        this.searchParams.groupId = '';
        this.searchParams.tenantId = '';
      }
      this.searchParams.agentId = '';
    },
    // 获取统计数据文本
    getNumText(text, status) {
      const statusMap = {
        '0': 'unpaid',
        '1': 'unpaidNotice',
        '2': 'verifying',
        '3': 'submitted',
        '4': 'accounted',
        '5': 'paid',
        '6': 'expire',
        '7': 'failures',
        '8': 'notPaymentNotice',
        '9': 'isPaymentNotice'
      };
      let num = 0;
      if (status == '0-1') {
        num += this.statistics.unpaidNotice || 0;
        num += this.statistics.notPaymentNotice || 0;
        num += this.statistics.isPaymentNotice || 0;
      } else {
        num = this.statistics[statusMap[status]] || 0;
      }
      if (status === 'null') {
        num += this.statistics.unpaidNotice || 0;
        num += this.statistics.verifying || 0;
        num += this.statistics.submitted || 0;
        num += this.statistics.accounted || 0;
        num += this.statistics.paid || 0;
        num += this.statistics.expire || 0;
        num += this.statistics.failures || 0;
        num += this.statistics.notPaymentNotice || 0;
        num += this.statistics.isPaymentNotice || 0;
      }
      if (status == 0 || status == 1) {
        return (
          <div>
            {text}(<span>{num}</span>)
          </div>
        );
      } else {
        return (
          <div>
            {text}(<span style="color: #236dff">{num}</span>)
          </div>
        );
      }
    },
    listCallback() {
      this.getStatistics();
    },
    getStatistics() {
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      delete params.renewalState;
      this.$http({
        url: '/buz/policy/renewal/statistics',
        type: 'POST',
        data: {
          ...params
        }
      }).then(res => {
        this.statistics = res.data;
      });
    },
    // 查询申请人
    getUserList() {
      this.$http({
        url: '/buz/userBase/list',
        type: 'POST',
        data: {
          selectSub: 1,
          tenantId: this.searchParams.tenantId
        }
      }).then(res => {
        this.userList = res.data.filter(i => i.ifaType != 2);
      });
    },
    // 跳转保单编辑
    goPolicy(row) {
      if (!row.policyId) {
        this.$notice.error('policyId不存在');
        return;
      }
      this.openPageTabTags('/operate/orderManage/insuredOrder/policyDetail', {
        backUrl: this.$route.fullPath,
        id: row.policyId,
        reqUrl: 'read/detail'
      });
    },
    //导出数据
    handleExport() {
      this.$units.downloadFile('/admin/policy/renewal/export', this.formData, 'POST');
    },
    // 选择保司，查询产品
    companyChange() {
      this.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { companyId: this.searchParams.companyId }
      }).then(res => {
        this.searchProductList = res.data;
      });
    },
    // 查询商户
    getTenantList(keyword) {
      if (!keyword) {
        return;
      }
      return this.$http({
        url: '/buz/merchantBase/read/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999,
          companyName: keyword
        }
      }).then(res => {
        return res.data;
      });
    },
    // 查询所有保司
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 跳转详情
    goDetail(data = {}) {
      this.openPageTabTags('/operate/renewalManage/renewalDetail', {
        id: data.id || '',
        renewalState: data.renewalState
      });
    },
    // 设置参数
    setListParams(params) {
      this.getColumns(params.renewalState);
      // 当期保费到期日
      params.expireDateStart = '';
      params.expireDateEnd = '';
      if (params.expireDate && params.expireDate[0]) {
        params.expireDateStart = params.expireDate[0];
        params.expireDateEnd = params.expireDate[1];
      }
      delete params.expireDate;
      delete params.id;
      // 保单生效日期
      params.effectDateStart = '';
      params.effectDateEnd = '';
      if (params.effectDate && params.effectDate[0]) {
        params.effectDateStart = params.effectDate[0];
        params.effectDateEnd = params.effectDate[1];
      }
      delete params.effectDate;
      if (params.renewalState == '-1') {
        delete params.renewalState;
      } else if (params.renewalState == '0') {
        if (params.subRenewalState == '1') {
          params.renewalState = '1';
        }
      }
      if (params.renewalState || params.renewalState === '0') {
        if (params.renewalState === '0') {
          params.renewalState = [0, 1];
        } else {
          params.renewalState = [Number(params.renewalState)];
        }
      }
    },
    // 删除
    del(row) {
      this.$notice.inquiry('确定删除吗？').then(() => {
        this.listLoading = true;
        this.$http({
          url: '/admin/reservation/logic/del',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.getList();
        });
      });
    },
    // 下载报送单
    downloadFile(row) {
      this.$units.downloadFun({
        url: '/admin/reservation/detail/export',
        params: {
          rId: row.id
        }
      });
    },
    // 查看行程单
    jumpTrip(row) {
      const url = this.$config.h5Base + '/apps/tripDetail?reservationId=' + row.id;
      window.open(url);
    }
  }
};
</script>
